import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import PrimaryButton from './buttons/PrimaryButton';

export default function PayNowOption({ onContinue }) {
  return (
    <div className="mb-6">
      <div className="p-4 sm:p-5 border-2 border-primary-blue bg-secondary-blue rounded-lg mb-4">
        <div className="flex items-start gap-3">
          <div className="p-3 mt-1 bg-blue-200 rounded-full">
            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-blue flex items-center justify-center">
              <FontAwesomeIcon icon={['fas', 'check']} className="text-white" />
            </div>
          </div>
          <div className="flex-1">
            <h3 className="font-semibold text-base sm:text-lg mb-1">
              You can still complete your checkout with Credit Key by paying in
              full
            </h3>
            <p className="text-sm text-gray-700 mb-3">
              Pay in full today using your business bank account. No fees,
              instant processing.
            </p>
            <div className="flex flex-wrap gap-4">
              <span className="flex items-center gap-1 text-xs text-gray-500">
                <FontAwesomeIcon
                  icon={['fas', 'check']}
                  className="text-green-600 text-xs"
                />
                No fees
              </span>
              <span className="flex items-center gap-1 text-xs text-gray-500">
                <FontAwesomeIcon
                  icon={['fas', 'check']}
                  className="text-green-600 text-xs"
                />
                Secure bank transfer
              </span>
            </div>
          </div>
        </div>
      </div>
      <PrimaryButton
        buttonText="Continue to Pay in Full"
        buttonColor="bg-primary-blue border-primary-blue hover:bg-primary-blue-hover"
        onClick={onContinue}
      />
    </div>
  );
}
